import { useState } from "react";

import { Button } from "@components/v2/buttons/button";
import { ScheduledExportForm } from "@features/data-export-v2/components/scheduled-export-form/scheduled-export-form";
import { Modal } from "@shared/modal";

export const CreateScheduledExportV2ButtonWithModal = () => {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  return (
    <>
      <Modal
        variant="v2"
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        contentClassName="max-w-[1300px] max-h-dvh"
      >
        <ScheduledExportForm onClose={() => setIsExportModalOpen(false)} />
      </Modal>
      <Button variant="primary" onClick={() => setIsExportModalOpen(true)}>
        CREATE SCHEDULED EXPORT
      </Button>
    </>
  );
};
